window.Calculator = function () {
    var el = this;
    el.prices = {};
    el.price = {};
    el.priceGroupId = 0;
    el.currency = {};
    el.cost = 0;
    el.count = 1;

    el.init = function () {
        el.price = el.getPrice();
        el.calcCost();
    };
    
    el.getPrice = function() {
        var price = {};
        for (count in el.prices) {
            if(el.count >= count) {
                price = el.prices[count];
            }
        }
        
        return price;
    };

    el.getFormatCost = function(formatId) {
        var cost = 0;

        var price = el.price[el.priceGroupId][el.product.id];
        
        if (price.hasOwnProperty(formatId)) {
            cost += parseFloat(price[formatId] * el.count);
        }
        return cost;
    };

    el.calcCost = function () {
        el.cost = 0;
        var price = el.price[el.priceGroupId][el.product.id];
        if (price.hasOwnProperty(0)) {
            el.cost += parseFloat(price[0] * el.count);
        }
        
        var workareas = el.workData.workareas;
        var workareaId, workarea;
        for (workareaId in workareas) {
            workarea = workareas[workareaId];
            
            if (parseInt(el.category.calc_all_workareas) === 1 || el.workarea.isExistData(workareaId)) {
                el.cost += el.getFormatCost(workarea.format.id);
            }
        }
        el.setCost();
    };

    el.setCost = function () {
        $('.cost').text(el.cost.toFixed(2));
    };
};